/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as BarLayerSpec } from '../../../../layer/preset/bar/bar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type BarLayerType = StandardChartLayerSpec & BarLayerSpec & ILayerTypeSpec;

// 创建柱状图数据类型验证器
const validateBarDataTypes = createDataTypeValidator('bar', [
  { field: 'x', type: ['string', 'date'] },
  { field: 'y', type: 'number', array: true },
  { field: 'z', type: 'string', required: false }
]);

// 创建柱状图编码验证器
const validateBarEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y', array: true },
  { field: 'z', required: false }
]);

// 额外的检查函数
const additionalBarChecks = (layer: BarLayerType) => {
  const { encoding } = layer;
  if (encoding.z && Array.isArray(encoding.y) && encoding.y.length > 1) {
    // 潜规则：多Y轴与Z维度不能同时使用，会降级为单Y轴
    utils.logger.warn(
      'warning',
      `Multiple Y axes with Z dimension is not supported. Using only the first Y field: "${encoding.y[0]}"`
    );
  }
};

// 创建并导出柱状图处理器
export const bar = createLayerProcessor<BarLayerType>(
  'bar',
  validateBarEncoding,
  validateBarDataTypes,
  additionalBarChecks
);
